import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white text-[#1A1A1A]">
        <Header />
        <main>
          <Hero />
          <Services />
          <About />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-center"
          theme="light"
          richColors={false}
          toastOptions={{
            classNames: {
              toast:
                "!bg-[#1A1A1A] !text-white !border !border-[#3F3F46] !rounded-none !font-sans",
              title: "!text-white",
              description: "!text-white/80",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
